import { getNameInitials } from '@framework/ui';
import { Avatar } from 'antd';
import clx from 'classnames';
import styled from 'styled-components';

const UserAvatarStyled = styled(Avatar)`
  margin-top: 4px;
  text-transform: uppercase;
  background-color: ${props => props.theme.colorTextSecondary};
  &.is-current-user {
    background-color: ${props => props.theme.colorPrimary};
  }
`;

export interface IUserAvatarProps {
  name?: string | null;
  isCurrentUser?: boolean;
}

/**
 * Avatar dell'utente che ha inviato la comunicazione
 */
export function UserAvatar(props: IUserAvatarProps) {
  const { name, isCurrentUser } = props;

  return (
    <UserAvatarStyled className={clx({ 'is-current-user': isCurrentUser })}>
      <span className="sr-only">{name}</span>
      <span aria-hidden="true">{getNameInitials(name)}</span>
    </UserAvatarStyled>
  );
}
